import React from 'react'
import { Col } from 'react-bootstrap'
import { ICommonProductListItemProps } from '../IProductListItemProps'

interface IProductItemHeaderProps extends ICommonProductListItemProps {}

const ProductItemHeader: React.FC<IProductItemHeaderProps> = ({ product, children }) => {
  return (
    <>
      <Col xs={12}>
        <div className='big-product-name-font' style={{ textAlign: 'left' }}>
          {product.name}
        </div>
      </Col>

      {children}
    </>
  )
}
export default ProductItemHeader
